/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* referrers-intelligence/assets/js/ref.js — category mix + scored top referrers + referrer journeys.
 * Expects the DOM from frontend/pages.php (data-ref="…" hooks). Uses window.GS.api. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["referrers-intelligence"] = "1.4.6"; } catch (e) {}

  var ORDER = ["search", "social", "ads", "email", "direct", "internal", "spam", "other"];
  var BAND = { low: "#1FA463", medium: "#D97706", high: "#DC2626" };
  var FALLBACK = "#94A3B8";
  var RANGE;                 // module-scoped: init() assigns it; loadOrigins()/loadBacklinks() read it
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function num(n) { return (+n || 0).toLocaleString(); }

  function ctl() {
    var d = document;
    return {
      rangeBtn: d.querySelector('[data-ref="rangeBtn"]'), rangeMenu: d.querySelector('[data-ref="rangeMenu"]'), rangeLabel: d.querySelector('[data-ref="range-label"]'),
      cats: d.querySelector('[data-ref="cats"]'), table: d.querySelector('[data-ref="table"]'),
      chains: d.querySelector('[data-ref="chains"]'), depnote: d.querySelector('[data-ref="depnote"]'),
      cpBtn: d.querySelector('[data-ref="cpBtn"]'), cpPanel: d.querySelector('[data-ref="copilot"]'), cpBody: d.querySelector('[data-ref="cp-body"]')
    };
  }

  /* Acquisition hub: a channel card opens an off-canvas briefing built from referrers' own data,
     with deep-links out to the specialised tools (stay-in-place, like the VI briefing). */
  var CHAN = { search: ["search-engines", TR('ri.f.search_engines')], social: ["social-media", TR('ri.f.social_media')], ads: ["ad-intel", "Ad Intel"] };
  var CH2CAMP = { search: TR('ri.f.organic_search'), social: TR('ri.f.social'), ads: TR('ri.f.paid_search'), email: TR('ri.f.email'), direct: TR('ri.f.direct'), referral: "Referral" };
  function refOcEnsure() {
    if (document.querySelector('[data-refoc="wrap"]')) return;
    var el = document.createElement("div");
    el.className = "ref-oc"; el.setAttribute("data-refoc", "wrap"); el.hidden = true;
    el.innerHTML = '<div class="ref-ocb" data-refoc="backdrop"></div>' +
      '<aside class="ref-ocp" role="dialog" aria-modal="true">' +
        '<header class="ref-oc-h"><i class="bi bi-signpost-split"></i><span data-refoc="title"></span><button class="ref-oc-x" data-refoc="close" aria-label="'+TT('ri.at.close')+'">&times;</button></header>' +
        '<div class="ref-oc-body" data-refoc="body"></div></aside>';
    document.body.appendChild(el);
    el.querySelector('[data-refoc="backdrop"]').addEventListener("click", refOcClose);
    el.querySelector('[data-refoc="close"]').addEventListener("click", refOcClose);
    document.addEventListener("keydown", function (e) { if (e.key === TR('referr.escape')) refOcClose(); });
  }
  function refOcQ(k) { var el = document.querySelector('[data-refoc="wrap"]'); return el ? el.querySelector('[data-refoc="' + k + '"]') : null; }
  function refOcClose() { var el = document.querySelector('[data-refoc="wrap"]'); if (el) { el.classList.remove("open"); el.hidden = true; } }
  function openChannel(key, d) {
    d = d || {}; var o = (d.categories || {})[key]; if (!o) return;
    var refs = (d.referrers || []).filter(function (r) { return r.category === key; }).slice(0, 6);
    refOcEnsure();
    var el = document.querySelector('[data-refoc="wrap"]');
    refOcQ("title").textContent = (o.label || key) + " traffic";
    var link = function (href, label) { return '<a class="ref-oc-link" href="' + href + '">' + esc(label) + ' <i class="bi bi-arrow-right"></i></a>'; };
    var deeper = "";
    if (CHAN[key]) deeper += link("/" + CHAN[key][0], "Open " + CHAN[key][1]);
    var camp = CH2CAMP[key];
    deeper += link("/marketing-campaigns" + (camp ? "?channel=" + encodeURIComponent(camp) : ""), "Marketing Campaigns") + link("/multi-touch-attribution", TR('referr.f2.multi_touch_attribution'));
    var topRefs = refs.length ? refs.map(function (r) {
      return '<div class="ref-oc-r"><span class="ref-oc-rh" title="' + esc(r.host) + '">' + esc(r.host) + "</span>" +
        '<span class="ref-oc-rs">rel ' + (+r.reliability || 0) + " \u00B7 intent " + (+r.intent || 0) + "</span></div>";
    }).join("") : '<div class="ref-oc-empty">'+TR('ri.f.no_individual_referrers_in_this_channe')+'</div>';
    refOcQ("body").innerHTML =
      '<section class="ref-oc-card"><div class="ref-oc-ch">'+TT('ri.js.this_channel')+'</div><div class="ref-oc-head">' + num(o.sessions) + " sessions</div>" +
        '<div class="ref-oc-meta">' + (+o.pct || 0) + "% of referred traffic</div></section>" +
      '<section class="ref-oc-card"><div class="ref-oc-ch">'+TT('ri.js.top_referrers')+'</div>' + topRefs + "</section>" +
      '<section class="ref-oc-card"><div class="ref-oc-ch">'+TT('ri.js.go_deeper')+'</div><div class="ref-oc-links">' + deeper + "</div></section>";
    el.hidden = false; (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () { el.classList.add("open"); });
  }

  function init() {
    if (document.body._refWired || !window.GS || !GS.api) return;
    document.body._refWired = 1;
    var c = ctl(); if (!c.cats) return;

    function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
    function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
    function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
    function preset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
    RANGE=(function(){try{var s=JSON.parse(localStorage.getItem("gs_ref_range")||"null");if(s&&s.preset)return preset(+s.preset);if(s&&s.from&&s.to)return s;}catch(e){}return preset(30);})();
    function _rpInit(){
      var btn=document.querySelector('[data-ref="rangeBtn"]'),menu=document.querySelector('[data-ref="rangeMenu"]'),lab=document.querySelector('[data-ref="range-label"]');
      if(!btn||!menu)return;
      if(lab&&RANGE.label)lab.textContent=RANGE.label;
      function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===RANGE.preset);});}
      btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
      document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
      function apply(r){RANGE=r;if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_ref_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";loadAll();}
      menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(preset(+b.getAttribute("data-preset")));});});
      var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
    }

    function stackBar(cats) {
      return '<div class="ref-bar">' + ORDER.map(function (k) {
        var o = cats[k]; if (!o || !o.pct) return "";
        return '<span style="width:' + o.pct + "%;background:" + (o.color || FALLBACK) + '" title="' + esc(o.label || k) + " " + o.pct + '%"></span>';
      }).join("") + "</div>";
    }
    function catCards(cats) {
      // show the categories that actually have traffic, biggest first, capped at 6
      var present = ORDER.map(function (k) { return [k, cats[k] || { sessions: 0, pct: 0 }]; })
        .filter(function (p) { return p[1].sessions > 0; })
        .sort(function (a, b) { return b[1].sessions - a[1].sessions; }).slice(0, 6);
      if (!present.length) present = [["search", cats.search || { sessions: 0, pct: 0 }]];
      return present.map(function (p) {
        var k = p[0], o = p[1];
        return '<div class="col-6 col-md"><div class="ref-stat ref-stat-click" data-chan="' + k + '" title="Explore ' + esc(o.label || k) + ' traffic" role="button" tabindex="0">' +
          '<div class="ref-stat-dot" style="background:' + (o.color || FALLBACK) + '"></div>' +
          '<div class="ref-stat-v">' + o.pct + '%</div>' +
          '<div class="ref-stat-l">' + esc(o.label || k) + "</div>" +
          '<div class="ref-stat-n">' + num(o.sessions) + " sessions</div>" +
          '<i class="bi bi-chevron-right ref-stat-go"></i></div></div>';
      }).join("");
    }
    function renderCats(d) {
      var cats = (d && d.categories) || {}, total = (d && d.total) || 0;
      if (c.depnote) c.depnote.hidden = total > 0;
      c.cats.innerHTML =
        '<div class="col-12"><div class="gs-card"><div class="gs-card-body">' +
          '<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">' +
            '<div class="fw-semibold">'+TT('ri.js.referrer_mix')+'</div>' +
            '<div class="gs-muted small">' + num(total) + " sessions</div></div>" +
          stackBar(cats) + '<div class="row g-2 mt-1">' + catCards(cats) + "</div>" +
        "</div></div></div>";
      Array.prototype.forEach.call(c.cats.querySelectorAll("[data-chan]"), function (el2) {
        var go = function () { openChannel(el2.getAttribute("data-chan"), d); };
        el2.addEventListener("click", go);
        el2.addEventListener("keydown", function (e) { if (e.key === TR('referr.enter') || e.key === " ") { e.preventDefault(); go(); } });
      });
    }

    function scoreBar(v, color) {
      /* One inline-flex wrapper, not two loose inline elements: in a narrow column the value used
         to wrap onto the next line and sit under the bar instead of beside it. */
      return '<span class="ref-scorewrap"><span class="ref-score"><span style="width:' + (+v || 0)
               + "%;background:" + color + '"></span></span><span class="ref-score-v">' + (+v || 0) + "</span></span>";
    }
    function catBadge(label, color) { return '<span class="ref-badge" style="background:' + color + "22;color:" + color + '">' + esc(label) + "</span>"; }
    /* The number alone means nothing to a reader; the backend sends the reason it was scored
       that way, so the badge can explain itself on hover instead of being decoration. */
    function riskBadge(risk, band, why) {
      var col = BAND[band] || FALLBACK;
      var t = why || ((band || "") + " risk (" + (+risk || 0) + "/100)");
      return '<span class="ref-riskwrap" title="' + esc(t) + '" tabindex="0">'
           + '<span class="ref-risk" style="background:' + col + '"></span> ' + (+risk || 0) + "</span>";
    }
    function renderTable(refs) {
      function refRow(r) {
        return '<tr><td class="text-truncate" style="max-width:180px" title="' + esc(r.host) + '">' + esc(r.host) + "</td>" +
          "<td>" + catBadge(r.label, r.color) + "</td><td>" + num(r.sessions) + "</td>" +
          "<td>" + scoreBar(r.reliability, "#1FA463") + "</td>" +
          "<td>" + scoreBar(r.intent, "#2A6FE8") + "</td>" +
          "<td>" + riskBadge(r.risk, r.risk_band, r.risk_why) + "</td></tr>";
      }
      refs = refs || [];
      if (window.GSMore) GSMore.mount({ container: c.table, table: true, colspan: 6, items: refs, pageSize: 20, emptyText: TR('ri.f.no_referrers_in_this_range'), render: refRow });
      else c.table.innerHTML = refs.length ? refs.map(refRow).join("") : '<tr><td colspan="6" class="gs-muted">'+TR('ri.f.no_referrers_in_this_range')+'</td></tr>';
    }

    function chip(cat, cats) { var m = (cats && cats[cat]) || {}, col = m.color || FALLBACK, lab = m.label || cat; return '<span class="ref-chip" style="background:' + col + "18;color:" + col + ";border-color:" + col + '55">' + esc(lab) + "</span>"; }
    function renderChains(chains, cats) {
      if (!chains || !chains.length) { c.chains.innerHTML = '<div class="gs-muted small">'+TR('ri.f.no_multi_visit_referrer_journeys_in_th')+'</div>'; return; }
      c.chains.innerHTML = chains.map(function (x) {
        var flow = x.chain.map(function (cat) { return chip(cat, cats); }).join('<span class="ref-arrow">&rarr;</span>');
        return '<div class="ref-journey"><div class="ref-flow">' + flow + "</div>" +
          '<div class="ref-jv">' + num(x.visitors) + ' <span class="gs-muted">visitor' + (x.visitors === 1 ? "" : "s") + "</span></div></div>";
      }).join("");
    }

    function stateReason(d) {
      if (!d) return TR('referr.p.couldn_t_load_this_right_now_please_');
      if (d.gated) return TR('referr.p.referrers_intelligence_isn_t_availab');
      if (d.error === "plugin_not_loaded") return TR('referr.p.referrers_intelligence_isn_t_enabled');
      if (!d.ok) return TR('referr.p.couldn_t_load_this_right_now_please_');
      return null;
    }
    function showDep(msg) {
      if (!c.depnote) return; c.depnote.hidden = false;
      c.depnote.innerHTML = '<div class="gs-card-body"><div class="fw-semibold mb-1"><i class="bi bi-info-circle me-1"></i>' + esc(msg) + "</div></div>";
    }
    // A prominent empty-state for hard states (plugin not loaded for this site / gated by plan):
    // clears the stale placeholders and explains why, with a route to fix it.
    function showState(msg) {
      if (c.cats) c.cats.innerHTML = "";
      if (c.chains) c.chains.innerHTML = "";
      if (c.table) c.table.innerHTML = "";
      if (!c.depnote) return; c.depnote.hidden = false;
      c.depnote.innerHTML =
        '<div style="text-align:center;padding:36px 20px;border:1px dashed #D5DBE3;border-radius:12px;background:#F8FAFC">'
        + '<div style="font-size:30px;color:#94A0B0;margin-bottom:10px"><i class="bi bi-plug"></i></div>'
        + '<div style="font-size:15px;font-weight:700;color:#1A1D24;max-width:480px;margin:0 auto 14px;line-height:1.5">' + esc(msg) + '</div>'
        + '<a href="/plugins" style="display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;background:#1FA463;color:#fff;font-weight:700;font-size:13px;text-decoration:none">'+TT('ri.js_manage_plugins')+'<i class="bi bi-arrow-right"></i></a>'
        + '</div>';
    }

    function load() {
      if (!GS.site) return;   // GS.site is null until gs:ready; the gs:ready/site-change handlers re-fire this
      var q = "/plugin/referrers-intelligence/get?site=" + encodeURIComponent(GS.site || "") + "&from=" + RANGE.from + "&to=" + RANGE.to;
      GS.api(q).then(function (r) {
        var d = r.data || null, reason = stateReason(d);
        if (reason) { showState(reason); return; }
        if ((d.total || 0) === 0) { showDep(TR('ri.f.no_referrer_traffic_in_this_range_yet_')); }
        else if (c.depnote) c.depnote.hidden = true;
        renderCats(d);
        renderTable(d.referrers);
        renderChains(d.chains, d.categories);
        LAST = d; if (CP_OPEN) cpRender();
        if (window.bootstrap && document.querySelectorAll) {
          document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) { try { new bootstrap.Tooltip(el); } catch (e) {} });
        }
      });
    }

    /* ---- Referrers Co-Pilot: a plain-language read of where traffic comes from and which sources to
       trust — rule-based on the loaded mix, scored referrers and chains. Same shape as the dashboard
       Co-Pilot (paragraphs / observations). No external calls. ---- */
    var LAST = null, CP_OPEN = false;
    if (c.cpBtn) c.cpBtn.addEventListener("click", cpToggle);

    function cpToggle() {
      CP_OPEN = !CP_OPEN;
      if (c.cpPanel) c.cpPanel.hidden = !CP_OPEN;
      if (c.cpBtn) c.cpBtn.classList.toggle("on", CP_OPEN);
      if (CP_OPEN) cpRender();
    }
    function catTop(cats) {
      var best = null;
      ORDER.forEach(function (k) { var o = cats[k]; if (o && o.sessions > 0 && (!best || o.sessions > best.o.sessions)) best = { k: k, o: o }; });
      return best;
    }
    function buildRefCopilot(d) {
      var out = { paragraphs: [], observations: [] };
      if (!d || (d.total || 0) === 0) { out.paragraphs.push(TR('ri.f.once_referred_traffic_comes_in_i_u2019')); return out; }
      var cats = d.categories || {}, refs = d.referrers || [], chains = d.chains || [];
      var tc = catTop(cats);
      if (tc) out.paragraphs.push(TR('referr.p.your_referred_traffic_is_led_by') + String(tc.o.label || tc.k).toLowerCase() + " at " + tc.o.pct + "% (" + num(tc.o.sessions) + " sessions).");
      if (refs.length) {
        var t = refs[0];
        out.paragraphs.push(TR('referr.p.your_single_biggest_source_is') + t.host + " (" + (t.label || "") + "): reliability " + t.reliability + "/100, intent " + t.intent + "/100" +
          (t.risk_band === "high" ? ", and it scores high-risk \u2014 worth a look for spam or bots." : "."));
      }
      var hiRisk = refs.filter(function (r) { return r.risk_band === "high"; });
      if (hiRisk.length) out.observations.push(hiRisk.length + " source" + (hiRisk.length === 1 ? "" : "s") + " scored high-risk (e.g. " + hiRisk[0].host + ") \u2014 likely spam or bot referrers; consider excluding them.");
      var byIntent = refs.slice().filter(function (r) { return r.intent >= 60; }).sort(function (a, b) { return b.intent - a.intent; });
      if (byIntent.length && byIntent[0].host !== (refs[0] && refs[0].host)) out.observations.push(byIntent[0].host + " sends unusually high-intent visitors (intent " + byIntent[0].intent + ") \u2014 a good source to invest in.");
      var weak = refs.filter(function (r) { return r.reliability < 40 && r.sessions > 0; });
      if (weak.length) out.observations.push(weak.length + " source" + (weak.length === 1 ? "" : "s") + " score low on reliability \u2014 treat their numbers with caution.");
      if (chains.length) {
        var top = chains[0];
        out.paragraphs.push("A common path in: " + top.chain.join(" \u2192 ") + " (" + num(top.visitors) + " visitor" + (top.visitors === 1 ? "" : "s") +
          "). Multi-touch journeys like this mean last-click alone undersells your top-of-funnel sources.");
      }
      return out;
    }
    function cpRender() {
      if (!c.cpBody) return;
      var r = buildRefCopilot(LAST);
      var html = (r.paragraphs || []).map(function (p) { return '<p class="ref-cp-p">' + esc(p) + "</p>"; }).join("");
      if (r.observations && r.observations.length) html += '<div class="ref-cp-sec">'+TT('ri.js.what_stands_out')+'</div>' +
        r.observations.map(function (o) { return '<div class="ref-cp-obs"><i class="bi bi-lightbulb"></i><span>' + esc(o) + "</span></div>"; }).join("");
      c.cpBody.innerHTML = html || '<p class="ref-cp-p">'+TR('ri.f.nothing_to_read_in_this_range_yet')+'</p>';
    }

    /* The bespoke inline panel was retired in favour of the one Co-Pilot every plugin now shares.
       Feed the same read into the shared off-canvas; it calls this again each time it opens, so it
       always reflects the current range. gs:ready guarantees GSCopilot has loaded (footer order). */
    document.addEventListener("gs:ready", function () {
      if (window.GSCopilot) window.GSCopilot.register("referrers-intelligence", function () { return buildRefCopilot(LAST); });
    });

    function loadAll() { load(); loadOrigins(); refreshBacklinksIfVisible(); }
    _rpInit();
    document.addEventListener("gs:ready", loadAll);
    document.addEventListener("gs:site-change", loadAll);
    loadAll();
  }

  /* ── Origin Intelligence ────────────────────────────────────────────────────
     Reads /origins once and draws it three ways: the flow from origin to landing
     page, origins plotted by traffic against arriving intent, and the behaviour
     that followed each click. All hand-built SVG in the product palette — the
     dashboard draws these same shapes, and a chart library would be 60x the size
     of the data it renders. */
  var OI = { AC: "#1FA463", BL: "#2A6FE8", AM: "#D97706", RD: "#DC2626", PU: "#6C4BE8", MU: "#8C95A1" };

  function oiEl(k) { return document.querySelector('[data-ref="' + k + '"]'); }
  function oiNum(n) { n = +n || 0; return n >= 1e6 ? (n / 1e6).toFixed(1) + "M" : n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  function oiEsc(x) { return String(x == null ? "" : x).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function oiBand(v) { return v >= 65 ? OI.AC : v >= 40 ? OI.BL : v >= 20 ? OI.AM : OI.RD; }
  function oiSvg(tag, attrs) {
    var e = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for (var k in attrs) if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    return e;
  }

  /* Origin -> landing page. Ribbon thickness is sessions, colour is the intent those
     visitors arrived with, so a fat red ribbon is a big source sending poor traffic. */
  function oiFlow(origins) {
    var svg = oiEl("oi-flow"); if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);

    var src = origins.filter(function (o) { return o.sessions > 0; }).slice(0, 6);
    if (!src.length) return;

    // collect landing pages across the shown origins
    var pages = {}, links = [];
    src.forEach(function (o) {
      (o.landing || []).slice(0, 3).forEach(function (l) {
        pages[l.path] = (pages[l.path] || 0) + l.sessions;
        links.push({ from: o.host, to: l.path, v: l.sessions, o: o });
      });
    });
    var dst = Object.keys(pages).sort(function (a, b) { return pages[b] - pages[a]; }).slice(0, 7);
    links = links.filter(function (l) { return dst.indexOf(l.to) >= 0; });
    if (!links.length) return;

    var W = 900, rowH = 34, padY = 14;
    var H = Math.max(src.length, dst.length) * rowH + padY * 2;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    svg.setAttribute("height", H);

    var maxV = Math.max.apply(null, links.map(function (l) { return l.v; }).concat([1]));
    var lx = 8, rx = W - 8, colW = 190;
    var yOf = {}, yOfD = {};
    src.forEach(function (o, i) { yOf[o.host] = padY + i * rowH + rowH / 2; });
    dst.forEach(function (p, i) { yOfD[p] = padY + i * rowH + rowH / 2; });

    links.forEach(function (l) {
      var y1 = yOf[l.from], y2 = yOfD[l.to];
      var x1 = lx + colW, x2 = rx - colW;
      var w = Math.max(2, (l.v / maxV) * 16);
      var beh = l.o.behaviour;
      var col = beh ? oiBand(beh.intent) : (l.o.color || OI.MU);
      var d = "M" + x1 + " " + y1 + " C" + (x1 + 90) + " " + y1 + " " + (x2 - 90) + " " + y2 + " " + x2 + " " + y2;
      var path = oiSvg("path", { d: d, stroke: col, "stroke-width": w, fill: "none",
                                 "stroke-linecap": "round", opacity: ".45", class: "ref-rib" });
      var ttl = oiSvg("title"); ttl.textContent = l.from + " → " + l.to + " · " + l.v + " session" + (l.v === 1 ? "" : "s")
        + (beh ? " · intent " + beh.intent : "");
      path.appendChild(ttl);
      svg.appendChild(path);
    });

    src.forEach(function (o) {
      var y = yOf[o.host];
      svg.appendChild(oiSvg("circle", { cx: lx + colW, cy: y, r: 4, fill: o.color || OI.MU }));
      var t = oiSvg("text", { x: lx, y: y + 4, "font-size": "12", fill: "#3C4350" });
      t.textContent = o.label.length > 26 ? o.label.slice(0, 25) + "…" : o.label;
      svg.appendChild(t);
    });
    dst.forEach(function (p) {
      var y = yOfD[p];
      svg.appendChild(oiSvg("circle", { cx: rx - colW, cy: y, r: 4, fill: "#C7CFDA" }));
      var t = oiSvg("text", { x: rx, y: y + 4, "font-size": "12", fill: "#3C4350", "text-anchor": "end" });
      t.textContent = p.length > 26 ? p.slice(0, 25) + "…" : p;
      svg.appendChild(t);
    });

    var lg = oiEl("oi-legend");
    if (lg) lg.innerHTML = [[TR('ri.f.high_intent'), OI.AC], [TR('ri.f.evaluating'), OI.BL], [TR('ri.f.low_intent'), OI.AM], ["Poor", OI.RD]]
      .map(function (x) { return '<span><i style="background:' + x[1] + '"></i>' + x[0] + "</span>"; }).join("");
  }

  /* Traffic against arriving intent. Bubble area is pageviews. */
  function oiBubbles(origins) {
    var svg = oiEl("oi-bubbles"); if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var rows = origins.filter(function (o) { return o.sessions > 0; }).slice(0, 14);
    if (!rows.length) return;

    var W = 620, H = 300, pad = { l: 40, r: 16, t: 14, b: 30 };
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    var maxS = Math.max.apply(null, rows.map(function (o) { return o.sessions; }).concat([1]));
    var maxP = Math.max.apply(null, rows.map(function (o) { return o.pageviews; }).concat([1]));

    [0, 25, 50, 75, 100].forEach(function (v) {
      var y = H - pad.b - (v / 100) * (H - pad.t - pad.b);
      svg.appendChild(oiSvg("line", { x1: pad.l, y1: y, x2: W - pad.r, y2: y, stroke: "#E6E9EF" }));
      var t = oiSvg("text", { x: pad.l - 8, y: y + 4, "font-size": "10", fill: "#8C95A1", "text-anchor": "end" });
      t.textContent = v; svg.appendChild(t);
    });
    var yl = oiSvg("text", { x: 12, y: 20, "font-size": "10.5", fill: "#8C95A1" });
    yl.textContent = "intent"; svg.appendChild(yl);
    var xl = oiSvg("text", { x: W - pad.r, y: H - 8, "font-size": "10.5", fill: "#8C95A1", "text-anchor": "end" });
    xl.textContent = "sessions →"; svg.appendChild(xl);

    rows.forEach(function (o, i) {
      var iv = o.behaviour ? o.behaviour.intent : o.intent_hint;
      var x = pad.l + (Math.sqrt(o.sessions / maxS)) * (W - pad.l - pad.r - 20) + 10;
      var y = H - pad.b - (Math.max(0, Math.min(100, iv)) / 100) * (H - pad.t - pad.b);
      var r = 6 + Math.sqrt(o.pageviews / maxP) * 20;
      var c = oiSvg("circle", { cx: x.toFixed(1), cy: y.toFixed(1), r: r.toFixed(1),
                                fill: o.color || OI.MU, opacity: ".55", stroke: o.color || OI.MU,
                                "stroke-width": "1.5", class: "ref-bub", style: "--d:" + (i * 0.05) + "s" });
      var ttl = oiSvg("title");
      ttl.textContent = o.label + " · " + o.sessions + " sessions · " + o.pageviews + " pageviews · intent " + iv
        + (o.behaviour ? "" : " (estimated from source type)");
      c.appendChild(ttl); svg.appendChild(c);
    });
  }

  /* One card per origin: what arrived, where it landed, how it behaved. */
  function oiCards(d) {
    var host = oiEl("oi-cards"); if (!host) return;
    var rows = (d.origins || []).slice(0, 12);
    if (!rows.length) { host.innerHTML = '<div class="gs-muted small">'+TR('ri.f.no_origins_in_this_range')+'</div>'; return; }
    var note = oiEl("oi-behnote");
    if (note && !d.has_behaviour)
      note.textContent = TT('ri.a.enable_visitor_intelligence_to_s');

    host.innerHTML = rows.map(function (o) {
      var b = o.behaviour;
      var land = (o.landing || []).slice(0, 3).map(function (l) {
        return '<a class="ref-oland" href="/heatmaps?page=' + encodeURIComponent(l.path) + '" title="'+TT('ri.tip_heatmap')+'">'
             + oiEsc(l.path) + ' <b>' + oiNum(l.sessions) + '</b></a>';
      }).join("");
      var triad = b ? [[TR('ri.f.intent'), b.intent, OI.AC], [TR('ri.f.friction'), b.frustration, OI.RD], [TR('ri.f.attention'), b.attention, OI.PU]]
        .map(function (t) {
          return '<div class="ref-otri"><span>' + t[0] + '</span><i><b style="width:' + Math.max(0, Math.min(100, t[1]))
               + '%;background:' + t[2] + '"></b></i><em>' + t[1] + "</em></div>";
        }).join("") : '<div class="gs-muted small">'+TR('ri.f.no_behavioural_scores_yet')+'</div>';
      return '<article class="ref-ocard">'
        + '<div class="ref-ohead"><span class="ref-odot" style="background:' + (o.color || OI.MU) + '"></span>'
        + '<b>' + oiEsc(o.label) + '</b><span class="ref-ocat">' + oiEsc(o.cat_label) + "</span></div>"
        + '<div class="ref-ostats"><span>' + oiNum(o.sessions) + " sessions</span><span>" + oiNum(o.visitors)
        + " visitors</span><span>" + o.pages_per_session + " pages/visit</span><span>" + o.share + "%</span></div>"
        + '<div class="ref-otriad">' + triad + "</div>"
        + (land ? '<div class="ref-olands">' + land + "</div>" : "")
        + "</article>";
    }).join("");
  }

  function oiUtm(c) {
    var host = oiEl("oi-utm"); if (!host) return;
    var blocks = [["campaigns", TR('ri.f.campaigns')], ["sources", TR('ri.f.sources')], ["mediums", TR('ri.f.mediums')]];
    var out = blocks.map(function (b) {
      var rows = (c && c[b[0]]) || [];
      if (!rows.length) return "";
      var max = Math.max.apply(null, rows.map(function (r) { return r.sessions; }).concat([1]));
      return '<div class="ref-utmb"><h4>' + b[1] + "</h4>" + rows.slice(0, 5).map(function (r) {
        return '<div class="ref-utmr"><span>' + oiEsc(r.label) + '</span><i><b style="width:'
             + Math.round(r.sessions / max * 100) + '%"></b></i><em>' + oiNum(r.sessions) + "</em></div>";
      }).join("") + "</div>";
    }).join("");
    host.innerHTML = out || '<div class="gs-muted small">No UTM-tagged traffic in this range. Tag your links with utm_source to see campaigns here.</div>';
  }

  function loadOrigins() {
    if (!window.GS || !GS.api || !GS.site) return;
    /* Same two date inputs the rest of the page reads — there is no separate range state here,
       and inventing one would let the panels disagree with the table above them. */
    var f = {value: RANGE.from}, t = {value: RANGE.to};
    var q = "/plugin/referrers-intelligence/origins?site=" + encodeURIComponent(GS.site)
          + "&from=" + RANGE.from + "&to=" + RANGE.to;
    GS.api(q).then(function (r) {
      var d = (r && r.data) ? r.data : r;
      if (!d || !d.origins) return;
      var wrap = oiEl("oi"); if (wrap) wrap.hidden = false;
      var t = oiEl("oi-tot");
      if (t && d.totals) t.innerHTML = oiNum(d.totals.sessions) + " sessions &middot; " + oiNum(d.totals.visitors)
        + " visitors &middot; " + (d.origins.length) + " origins";
      oiFlow(d.origins); oiBubbles(d.origins); oiCards(d); oiUtm(d.campaigns);
    }).catch(function () { /* the rest of the page still works */ });
  }

  /* ── Backlinks tab ────────────────────────────────────────────────────────
     Inbound links from other sites (referrers minus direct / internal / organic
     search), scored on the behaviour that followed the click. Reuses the origin
     card look; landing pages deep-link into Heatmaps. Data: /backlinks. */
  function blCard(o) {
    var badge = o.source === "tossit" ? '<span class="ref-blbadge ref-bl-tossit">Tossit</span>'
              : o.source === "rentanad" ? '<span class="ref-blbadge ref-bl-raa">'+TR('referr.rent_an_ad')+'</span>' : "";
    var toxic = o.toxic ? '<span class="ref-blbadge ref-bl-toxic" data-bs-toggle="tooltip" title="'+TT('ri.tip_spam')+'">'+TR('ri.f.toxic')+'</span>' : "";
    var persona = o.persona ? '<span class="ref-ocat">' + oiEsc(o.persona) + "</span>" : "";
    var SC = [
      [TR('ri.f.quality'), o.quality, "#1FA463", TR('ri.f.composite_source_reliability_engagemen')],
      [TR('ri.f.intent'), o.intent, "#2A6FE8", TR('ri.f.how_purchase_engagement_ready_visitors')],
      [TR('ri.f.emotional'), o.emotional, "#8B5CF6", TR('ri.f.attention_minus_frustration_after_arri')],
      [TR('ri.f.conversion'), o.conversion, "#D97706", TR('ri.f.engagement_proxy_depth_of_visit_and_ev')]
    ];
    var scores = SC.map(function (s) {
      var v = (s[1] == null) ? null : Math.max(0, Math.min(100, s[1]));
      var bar = (v == null) ? '<i></i><em class="gs-muted">&mdash;</em>'
                            : '<i><b style="width:' + v + "%;background:" + s[2] + '"></b></i><em>' + v + "</em>";
      return '<div class="ref-otri" data-bs-toggle="tooltip" title="' + oiEsc(s[3]) + '"><span>' + s[0] + "</span>" + bar + "</div>";
    }).join("");
    var land = (o.landing || []).slice(0, 3).map(function (l) {
      return '<a class="ref-oland" href="/heatmaps?page=' + encodeURIComponent(l.path) + '" title="'+TT('ri.tip_heatmap')+'">'
           + oiEsc(l.path) + " <b>" + oiNum(l.sessions) + "</b></a>";
    }).join("");
    return '<article class="ref-ocard' + (o.toxic ? " ref-ocard-toxic" : "") + '">'
      + '<div class="ref-ohead"><span class="ref-odot" style="background:' + (o.color || OI.MU) + '"></span>'
      + '<b class="text-truncate" title="' + oiEsc(o.host) + '">' + oiEsc(o.label) + "</b>"
      + badge + toxic + persona + "</div>"
      + '<div class="ref-ostats"><span>' + oiNum(o.sessions) + " sessions</span><span>" + oiNum(o.visitors)
      + " visitors</span><span>" + o.share + "%</span></div>"
      + '<div class="ref-otriad">' + scores + "</div>"
      + (land ? '<div class="ref-olands">' + land + "</div>" : "")
      + "</article>";
  }

  function blRender(d) {
    var host = oiEl("bl-cards"); if (!host) return;
    var note = oiEl("bl-note"); if (note) note.textContent = d.note || "";
    var tot = oiEl("bl-tot");
    if (tot && d.totals) tot.innerHTML = oiNum(d.totals.domains) + " domains &middot; avg quality " + d.totals.avg_quality
      + (d.totals.toxic ? ' &middot; <span class="text-danger">' + d.totals.toxic + " toxic</span>" : "");
    var rows = d.backlinks || [];
    host.innerHTML = rows.length ? rows.map(blCard).join("")
      : '<div class="gs-muted small">'+TR('ri.f.no_inbound_links_from_other_sites_in_t')+'</div>';
    if (window.bootstrap) document.querySelectorAll('[data-ref-panel="backlinks"] [data-bs-toggle="tooltip"]').forEach(function (el) { try { new bootstrap.Tooltip(el); } catch (e) {} });
  }

  function loadBacklinks() {
    if (!window.GS || !GS.api || !GS.site) return;
    var f = {value: RANGE.from}, t = {value: RANGE.to};
    var q = "/plugin/referrers-intelligence/backlinks?site=" + encodeURIComponent(GS.site)
          + "&from=" + RANGE.from + "&to=" + RANGE.to;
    GS.api(q).then(function (r) { var d = (r && r.data) ? r.data : r; if (d) blRender(d); }).catch(function () {});
  }

  function blVisible() { var p = document.querySelector('[data-ref-panel="backlinks"]'); return !!(p && !p.hidden); }
  function refreshBacklinksIfVisible() { if (blVisible()) loadBacklinks(); }

  function wireTabs() {
    var tabs = document.querySelector('[data-ref="tabs"]'); if (!tabs || tabs._wired) return; tabs._wired = 1;
    tabs.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ref-tab]"); if (!btn) return;
      var name = btn.getAttribute("data-ref-tab");
      tabs.querySelectorAll("[data-ref-tab]").forEach(function (b) { b.classList.toggle("active", b === btn); });
      document.querySelectorAll("[data-ref-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-ref-panel") !== name; });
      if (name === "backlinks") loadBacklinks();
    });
  }

  function boot() { if (document.querySelector('[data-ref="cats"]')) init(); }
  /* Boot ONCE, after main.js resolves GS.site. The old DOMContentLoaded path raced that,
     firing every request with an empty site= (404) and then booting again on gs:ready. */
  var _booted = false;
  function _bootOnce() { if (_booted) return; _booted = true; boot(); }
  document.addEventListener("gs:ready", _bootOnce, { once: true });
  if (window.GS && GS.site) _bootOnce();
  if (document.readyState !== "loading") wireTabs(); else document.addEventListener("DOMContentLoaded", wireTabs);
})();
